module.exports = __webpack_public_path__ + "img/04n.7db2b900.png";